import { MessageId as MessageIdSchema } from "@redotech/effect-api-shared/ids/definitions";
import { isEmailChannel } from "@redotech/effect-api-shared/models/shopper-ai/conversation/channel-utils";
import type { SaveDraftInput } from "@redotech/effect-api-shared/models/shopper-ai/conversation/draft";
import type { SupportTicketDraftResponse } from "@redotech/effect-api-shared/rpc/support-ticket";

export type DraftCollectionItem = Omit<
  SupportTicketDraftResponse,
  "inReplyToMessageId"
> & { inReplyToMessageId: string | undefined };

export function buildSaveDraftPayload(
  item: DraftCollectionItem,
): SaveDraftInput {
  const inReplyToMessageId = item.inReplyToMessageId
    ? MessageIdSchema.make(item.inReplyToMessageId)
    : undefined;
  const plainContent = item.plainContent ?? undefined;
  const mentionedMongoUserIds =
    item.mentionedMongoUserIds && item.mentionedMongoUserIds.length > 0
      ? [...item.mentionedMongoUserIds]
      : undefined;

  if (isEmailChannel(item.channel)) {
    return {
      threadId: item.threadId,
      inReplyToMessageId,
      content: item.content,
      plainContent,
      attachments: item.attachments,
      mentionedMongoUserIds,
      channel: item.channel,
      channelData: item.channelData ?? {},
    };
  }
  return {
    threadId: item.threadId,
    inReplyToMessageId,
    content: item.content,
    plainContent,
    attachments: item.attachments,
    mentionedMongoUserIds,
    channel: item.channel,
    channelData: null,
  };
}
